import { helper } from '@ember/component/helper';
export default helper(function l10nEq([a, b]) {
  return a === b;
});